import React from 'react';
import Link from 'next/link';
import Icon from '@/components/ui/AppIcon';

const CTASection = () => {
  return (
    <section className="py-16 lg:py-24 relative overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-br from-primary/10 via-transparent to-secondary/10"></div>
      
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="max-w-4xl mx-auto">
          <div className="glassmorphic rounded-3xl p-8 lg:p-12 text-center">
            <div className="inline-flex items-center space-x-2 px-4 py-2 rounded-full bg-success/10 border border-success/20 mb-6">
              <Icon name="SparklesIcon" size={20} className="text-success" />
              <span className="text-sm font-semibold text-success">Beperkte tijd aanbieding</span>
            </div>

            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-display font-bold text-foreground mb-4">
              Start vandaag nog met AI
            </h2>
            <p className="text-lg text-muted-foreground mb-8 max-w-2xl mx-auto">
              Boek een gratis demo en ontdek hoe AI uw bedrijf kan transformeren. Geen verplichtingen, alleen mogelijkheden.
            </p>

            <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-8">
              <Link
                href="/contact"
                className="w-full sm:w-auto px-8 py-4 rounded-lg font-semibold text-lg bg-cta text-cta-foreground hover:bg-cta/90 transition-all duration-300 hover:shadow-elevated hover:-translate-y-0.5 inline-flex items-center justify-center space-x-2"
              >
                <span>Gratis demo boeken</span>
                <Icon name="ArrowRightIcon" size={20} />
              </Link>
              <Link
                href="/contact"
                className="w-full sm:w-auto px-8 py-4 rounded-lg font-semibold text-lg border border-primary text-primary hover:bg-primary hover:text-primary-foreground transition-all duration-300 inline-flex items-center justify-center space-x-2"
              >
                <span>Gratis AI-scan</span>
                <Icon name="MagnifyingGlassIcon" size={20} />
              </Link>
            </div>

            <div className="flex flex-wrap items-center justify-center gap-6 text-sm text-muted-foreground">
              <div className="flex items-center space-x-2">
                <Icon name="CheckCircleIcon" size={20} className="text-success" />
                <span>Geen creditcard vereist</span>
              </div>
              <div className="flex items-center space-x-2">
                <Icon name="CheckCircleIcon" size={20} className="text-success" />
                <span>30 dagen geld terug</span>
              </div>
              <div className="flex items-center space-x-2">
                <Icon name="CheckCircleIcon" size={20} className="text-success" />
                <span>Opzegbaar per maand</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;